<template>
  <div class="new_vip">
    <div class="content">
      <EmployeeAdd></EmployeeAdd>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import EmployeeAdd from "@/views/apply/employee/employeeAdd"
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
    }
  },
  components: {
    EmployeeAdd
  }
}
</script>

<style lang="scss" scoped>
.new_vip{
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  .content{
    background: #fff;
    overflow: auto;
    height: 100%;
  }
}
</style>